import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function PoliticaPrivacidad() {
  const navigate = useNavigate();

  return (
    <div className="login-fondo">
      <div style={styles.container}>
        <div style={styles.header}>
          <img src="/img/BAC-MT.png" alt="BAC MT" style={{ width: '60px' }} />
          <h1 style={styles.titulo}>Política de Privacidad</h1>
          <p style={styles.subtitulo}>BAC MT 2.0 — Sistema de Monitoreo</p>
        </div>

        <div style={styles.contenido}>
          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>1. Introducción</h2>
            <p style={styles.parrafo}>
              Laboratorios Bacon respeta su privacidad y se compromete a proteger sus datos personales. 
              Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos su información 
              en cumplimiento con la Ley 25.326 de Protección de Datos Personales de la República Argentina.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>2. Datos que Recopilamos</h2>
            <p style={styles.parrafo}>Al utilizar BAC MT 2.0, recopilamos los siguientes tipos de datos:</p>
            <ul style={styles.lista}>
              <li><strong>Datos de empresa:</strong> nombre de la organización, email corporativo, teléfono, zona horaria</li>
              <li><strong>Datos de usuario:</strong> nombre completo, dirección de correo electrónico, contraseña (encriptada), rol dentro de la organización</li>
              <li><strong>Datos de equipos:</strong> número de serie, placa identificatoria, descripción, estado operativo</li>
              <li><strong>Datos de eventos:</strong> registros técnicos generados por los dispositivos (temperatura, código de evento, timestamp)</li>
            </ul>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>3. Finalidad del Tratamiento</h2>
            <p style={styles.parrafo}>Utilizamos sus datos personales para:</p>
            <ul style={styles.lista}>
              <li>Proporcionar acceso al sistema de monitoreo</li>
              <li>Gestionar cuentas de usuario y permisos</li>
              <li>Enviar notificaciones relacionadas con el servicio (bienvenida, restablecimiento de contraseña)</li>
              <li>Mantener la seguridad y funcionamiento del sistema</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>4. Base Legal</h2>
            <p style={styles.parrafo}>
              El tratamiento de sus datos personales se basa en el consentimiento otorgado al registrarse 
              en la plataforma y en la ejecución del contrato de prestación de servicios con Laboratorios Bacon.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>5. Compartir Información</h2>
            <p style={styles.parrafo}>
              No compartimos, vendemos ni alquilamos sus datos personales a terceros. La información es 
              utilizada exclusivamente por Laboratorios Bacon para la operación del servicio.
            </p>
            <p style={styles.parrafo}>
              Dentro de su organización, los datos son visibles únicamente para usuarios con los permisos adecuados 
              según el rol asignado (administrador de empresa, operador, superadministrador).
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>6. Seguridad de los Datos</h2>
            <p style={styles.parrafo}>Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos:</p>
            <ul style={styles.lista}>
              <li>Contraseñas encriptadas mediante algoritmo bcrypt</li>
              <li>Autenticación mediante tokens JWT con tiempo de expiración</li>
              <li>Transmisión cifrada mediante HTTPS (en producción)</li>
              <li>Control de acceso basado en roles</li>
              <li>Logs de auditoría de accesos</li>
            </ul>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>7. Conservación de Datos</h2>
            <p style={styles.parrafo}>
              Conservamos sus datos personales mientras su cuenta permanezca activa y durante el tiempo 
              necesario para cumplir con las finalidades descritas y con las obligaciones legales aplicables.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>8. Sus Derechos (Ley 25.326)</h2>
            <p style={styles.parrafo}>Usted tiene derecho a:</p>
            <ul style={styles.lista}>
              <li><strong>Acceso:</strong> solicitar una copia de sus datos personales</li>
              <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos</li>
              <li><strong>Supresión:</strong> solicitar la eliminación de sus datos</li>
              <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos en determinadas circunstancias</li>
            </ul>
            <p style={styles.parrafo}>
              Para ejercer estos derechos, contacte a Laboratorios Bacon a través de los medios de contacto proporcionados.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>9. Cookies y Tecnologías Similares</h2>
            <p style={styles.parrafo}>
              Utilizamos tokens de autenticación almacenados localmente en su navegador para mantener su sesión activa. 
              No utilizamos cookies de terceros ni tecnologías de rastreo publicitario.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>10. Modificaciones a esta Política</h2>
            <p style={styles.parrafo}>
              Nos reservamos el derecho de actualizar esta Política de Privacidad. Los cambios se publicarán 
              en la plataforma y entrarán en vigencia inmediatamente.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>11. Contacto</h2>
            <p style={styles.parrafo}>
              Para consultas sobre esta Política de Privacidad o sobre el tratamiento de sus datos personales, 
              puede contactar a Laboratorios Bacon a través de los medios proporcionados en el equipo o en nuestra página web.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>12. Autoridad de Aplicación</h2>
            <p style={styles.parrafo}>
              La Agencia de Acceso a la Información Pública es la autoridad de aplicación de la Ley 25.326. 
              Puede presentar reclamos ante dicha agencia si considera que sus derechos han sido vulnerados.
            </p>
          </section>

          <p style={styles.fecha}>Última actualización: Mayo 2026</p>
        </div>

        <div style={styles.footer}>
          <button style={styles.btnVolver} onClick={() => navigate('/login')}>
            ← Volver al login
          </button>
          <p style={styles.copyright}>© 2026 Laboratorios Bacon</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '800px',
    margin: '40px auto',
    backgroundColor: 'var(--bg-card)',
    borderRadius: '12px',
    padding: '40px',
    border: '1px solid var(--border)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
    paddingBottom: '24px',
    borderBottom: '1px solid var(--border)',
  },
  titulo: {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginTop: '16px',
    marginBottom: '8px',
  },
  subtitulo: {
    fontSize: '0.9rem',
    color: 'var(--text-muted)',
  },
  contenido: {
    lineHeight: '1.6',
  },
  seccion: {
    marginBottom: '28px',
  },
  seccionTitulo: {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: 'var(--accent)',
    marginBottom: '12px',
  },
  parrafo: {
    fontSize: '0.9rem',
    color: 'var(--text-primary)',
    marginBottom: '12px',
  },
  lista: {
    fontSize: '0.9rem',
    color: 'var(--text-primary)',
    marginLeft: '24px',
    marginBottom: '12px',
  },
  link: {
    color: 'var(--accent)',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  fecha: {
    fontSize: '0.8rem',
    color: 'var(--text-muted)',
    fontStyle: 'italic',
    marginTop: '32px',
  },
  footer: {
    marginTop: '32px',
    paddingTop: '24px',
    borderTop: '1px solid var(--border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  btnVolver: {
    background: 'none',
    border: '1px solid var(--border-light)',
    color: 'var(--text-muted)',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontFamily: 'IBM Plex Sans, sans-serif',
  },
  copyright: {
    fontSize: '0.8rem',
    color: 'var(--text-muted)',
  },
};

export default PoliticaPrivacidad;